import React, { useMemo } from 'react';
import { browserTimeZone, timeZoneOptions, zonedTimeToEpoch } from '../utils/schedule';
export interface ScheduleDraft {
  date: string;
  time: string;
  timeZone: string;
}
interface ScheduleFieldsProps {
  value: ScheduleDraft;
  disabled?: boolean;
  idPrefix: string;
  onChange: (next: ScheduleDraft) => void;
}
export const emptySchedule = (): ScheduleDraft => ({
  date: '',
  time: '',
  timeZone: browserTimeZone()
});
export function scheduleToEpoch(draft: ScheduleDraft): number | null {
  if (!draft.date || !draft.time) return null;
  return zonedTimeToEpoch(draft.date, draft.time, draft.timeZone);
}
const inputClass = 'w-full rounded-lg border border-line bg-raised px-3 py-2.5 text-sm text-white focus:border-gold focus:outline-none disabled:opacity-50 [color-scheme:dark]';
export function ScheduleFields({
  value,
  disabled,
  idPrefix,
  onChange
}: ScheduleFieldsProps) {
  const zones = useMemo(() => timeZoneOptions(), []);
  return <div className="grid grid-cols-2 gap-3" data-id="element-294" data-mp="5y9zkzvuhp2w">
      <div data-id="element-295" data-mp="5x8lsnng2ohh">
        <label htmlFor={`${idPrefix}-date`} className="text-xs font-medium text-muted" data-id="element-296" data-mp="5wp6lep6ie75">
          Date
        </label>
        <input id={`${idPrefix}-date`} type="date" value={value.date} disabled={disabled} onChange={e => onChange({
        ...value,
        date: e.target.value
      })} className={`mt-1 ${inputClass}`} data-id="element-297" data-mp="3s5qdjhvuuf4b" />
      </div>
      <div data-id="element-298" data-mp="omoq7m293136">
        <label htmlFor={`${idPrefix}-time`} className="text-xs font-medium text-muted" data-id="element-299" data-mp="omx5fkluiihj">
          Start time
        </label>
        <input id={`${idPrefix}-time`} type="time" value={value.time} disabled={disabled} onChange={e => onChange({
        ...value,
        time: e.target.value
      })} className={`mt-1 ${inputClass}`} data-id="element-300" data-mp="epk4tog8b9nf" />
      </div>
      <div className="col-span-2" data-id="element-301" data-mp="34fnrpjija5e5">
        <label htmlFor={`${idPrefix}-zone`} className="text-xs font-medium text-muted" data-id="element-302" data-mp="34goz9e0cc9r4">
          Time zone
        </label>
        <select id={`${idPrefix}-zone`} value={value.timeZone} disabled={disabled} onChange={e => onChange({
        ...value,
        timeZone: e.target.value
      })} className={`mt-1 ${inputClass}`} data-id="element-303" data-mp="15y3tiukkjra2">
          {zones.map(z => <option key={z} value={z} data-id="element-304" data-mp="w66ch76vq53f">
              {z.replace(/_/g, ' ')}
            </option>)}
        </select>
      </div>
    </div>;
}